export const setHighlightPath = (nodes, edges, highlightPath, focusMode = false) => {
    // 🔧 สร้าง Set เพื่อให้ lookup เป็น O(1) แทนการใช้ .some(), .find() ที่เป็น O(n)
    const highlightedNodeIds = new Set(highlightPath.nodes.map(n => n));
    const highlightedEdgeIds = new Set(highlightPath.edges.map(e => e));

    const updatedNodes = nodes.map(node => {
        const isHighlighted = highlightedNodeIds.has(node.id);
        return {
            ...node,
            data: {
                ...node.data,
                focusMode: focusMode,
                highlighted: isHighlighted,
            }
        };
    });

    const updatedEdges = edges.map(edge => {
        const isHighlighted = highlightedEdgeIds.has(edge.id);
        return {
            ...edge,
            // selected: isHighlighted,
            style: {
                ...(edge.style || {}),
                strokeWidth: isHighlighted ? 2 : 2,
                stroke: isHighlighted ? "#1976d2" : "gray",
                opacity: focusMode ? (isHighlighted ? 1 : 0.6) : 1,
            },
            animated: isHighlighted ? true : false,
        };
    });

    return { nodes: updatedNodes, edges: updatedEdges };
};